function getView(viewName, title) {
    return (resolve, reject) => {
        require.ensure([], (require) => {
            let modules = require(`src/views/page/ems/examine/${viewName}`)
            modules.default.options.metaInfo = { title }
            resolve(modules)
        }, reject, 'plan')
    }
}

let routes = [
    {
        name: 'examineList',
        path: '/ems/examineList',
        meta: {
            title: '项目督查'
        }
    },
    {
        name: 'examineDetail',
        path: '/ems/examineDetail',
        meta: {
            title: '项目督查'
        }
    },
    {
        name: 'examineItemDetail',
        path: '/ems/examineitemDetail',
        meta: {
            title: '督查单详情'
        }
    },
    {
        name: 'examineEditor',
        path: '/ems/examineEditor',
        meta: {
            title: '编辑督查单'
        }
    },
    {
        name: 'examineScore',
        path: '/ems/examineScore',
        meta: {
            title: '综合评分'
        }
    },
    {
        name: 'problemEditor',
        path: '/ems/problemEditor',
        meta: {
            title: '添加项目检查问题'
        }
    },
    {
        name: 'problemLog',
        path: '/ems/problemLog',
        meta: {
            title: '问题记录'
        }
    },
    {
        name: 'problemDetail',
        path: '/ems/problemDetail',
        meta: {
            title: '问题详情'
        }
    },
    {
        name: 'problemRectification',
        path: '/ems/problemRectification',
        meta: {
            title: '问题整改'
        }
    },
    {
        name: 'rectificationLog',
        path: '/ems/rectificationLog',
        meta: {
            title: '问题整改'
        }
    },
    {
        name: 'problemAcceptance',
        path: '/ems/problemAcceptance',
        meta: {
            title: '问题验收'
        }
    }
]

routes.forEach((v) => {
    if (!v.redirect && !v.component) {
        v.component = getView(v.name, v.meta.title)
    }
})

export default routes



// WEBPACK FOOTER //
// ./src/router/modules/ems/examine.js